import React from 'react';
import { Info, Megaphone, MessageCircle, Archive } from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: Info,
      title: 'Pusat Informasi Wisuda',
      description: 'Jadwal acara, tata tertib, alur prosesi, dan informasi resmi kampus tersedia dalam satu percakapan.',
      color: 'sage'
    },
    {
      icon: Megaphone,
      title: 'Pengumuman Hari-H',
      description: 'Perubahan teknis dan pengumuman penting disampaikan secara serentak dan real-time.',
      color: 'terracotta'
    },
    {
      icon: MessageCircle,
      title: 'Interaksi Peserta Wisuda',
      description: 'Peserta dapat bertanya, mengirim pesan, foto, dan video langsung melalui WhatsApp.',
      color: 'sage'
    },
    {
      icon: Archive,
      title: 'Arsip Kenangan Digital',
      description: 'Seluruh konten peserta dikompilasi otomatis menjadi kenangan kolektif acara wisuda.',
      color: 'terracotta'
    }
  ];

  return (
    <section id="layanan" className="py-24 px-6 bg-gradient-to-br from-cream-100 to-sage-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Layanan Utama
          </h2>
        </div>
        
        <div className="grid md:grid-cols-2 gap-8">
          {services.map((service, index) => (
            <div 
              key={index}
              className="group p-8 bg-white rounded-2xl border-2 border-transparent hover:border-sage-300 transition-all duration-300 hover:shadow-xl"
            >
              <div className={`inline-flex p-4 rounded-xl mb-6 ${
                service.color === 'sage' ? 'bg-sage-100' : 'bg-terracotta-100'
              }`}>
                <service.icon className={`w-8 h-8 ${
                  service.color === 'sage' ? 'text-sage-600' : 'text-terracotta-600'
                }`} />
              </div>
              
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {service.title}
              </h3>
              
              <p className="text-gray-700 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
